import { render, staticRenderFns } from "./knowledge-atlas.vue?vue&type=template&id=b35247ca&scoped=true"
import script from "./knowledge-atlas.vue?vue&type=script&lang=js"
export * from "./knowledge-atlas.vue?vue&type=script&lang=js"
import style0 from "./knowledge-atlas.vue?vue&type=style&index=0&id=b35247ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35247ca",
  null
  
)

export default component.exports